import * as React from 'react';
import { FormControlLabel, FormGroup, Radio } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import _ from 'lodash';
import { FilterButton } from '../../../../../components/ContainerFilters/FilterButton';

export const AvailableForPickupFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);
  const [filterStates, setFilterStates] = React.useState({
    available: false,
    notAvailable: false,
  });

  const [open, setOpen] = React.useState(false);

  const controlLabelClasses = {
    label: 'font-medium text-sm',
    root: 'm-0 py-1 hover:bg-blue-200 rounded-sm',
  };

  React.useEffect(() => {
    setFilterStates({
      available: searchParams.availableForPickup === true,
      notAvailable: searchParams.availableForPickup === false,
    });
  }, [searchParams]);

  const handleChange = (key: string, value: boolean) => {
    const newFilterState = {
      available: false,
      notAvailable: false,
      [key]: value,
    };

    const defaultSearchParams = {
      importStatus: _.uniq(_.concat(searchParams.importStatus, ['yard', 'rail', 'unknown'])),
    };

    if (newFilterState.available === newFilterState.notAvailable) {
      setSearchParams({
        ...defaultSearchParams,
        availableForPickup: null,
      });
    } else {
      setSearchParams({
        ...defaultSearchParams,
        availableForPickup: newFilterState.available,
      });
    }

    setOpen(false);
  };

  const handleClearFilter = () => {
    setSearchParams({
      availableForPickup: null,
    });
  };

  return (
    <FilterButton
      title="Available for pickup"
      count={_.keys(_.pickBy(filterStates)).length}
      clearFilter={handleClearFilter}
      isOpen={open}
      onRequestOpen={setOpen}
    >
      <FormGroup className="px-2">
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Radio
              size="small"
              color="primary"
              checked={filterStates.available}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange('available', e.target.checked)
              }
            />
          }
          label="Available for pickup"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Radio
              size="small"
              color="primary"
              checked={filterStates.notAvailable}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange('notAvailable', e.target.checked)
              }
            />
          }
          label="Not available for pickup"
        />
      </FormGroup>
    </FilterButton>
  );
};
AvailableForPickupFilter.displayName = 'TrackAndTrace.Controls.filters.AvailableForPickupFilter';
